export default __webpack_public_path__ + "static/media/LogoML.e9f9042c.svg";